import React from "react";

function Construction() {
  window.scrollTo(0, 0);
  return (
    <div>
     
<section className="ftco-section" style={{padding:"0px"}}>
    <div className="container">
      <div className="row mb-5  mx-auto">
        <div className="heading-section ftco-animate fadeInUp ftco-animated">
        <h2 style={{color:"#3A3A3A"}}><b>Construction</b></h2>
            <div style={{color:"#5E5550"}}>
              <p>
              Not any lawyer can undertake this kind of practice.  It involves heavy documentation, and negotiation to ensure the smooth running of a constructional phase.
              </p>
              <p>
              This is a highly developing area ; one needs to do as little as look out the window form his or her office to see the number of construction projects taking place. 
              </p>
              <p>
              An understanding of contractual structures is necessary for this area owing to the fact that much of it will entail dealing with the world of construction.  Documentation related to consultants, suppliers and all sorts of contractors is dealt with in this area of law.
              </p>
              <p>
              This area also overlaps heavily with litigation as many claims may arise from this area due to delays in construction, or defects in building.
              </p>
              <p>
              The firm has been heavily involved with construction related work whether it was for reviewing  tender documents or construction documents as one of our main clients has been heavily involved in all sorts of construction law issues.  We have been entrusted with reviewing contracts ranging from cable supply, construction agreements or project management documents.
              </p>
            </div>
        </div>
      </div>
    </div>
  </section>
</div>
  );
}

export default Construction;
